import { render, staticRenderFns } from "./homeCateList.vue?vue&type=template&id=48021769&scoped=true"
import script from "./homeCateList.vue?vue&type=script&lang=js"
export * from "./homeCateList.vue?vue&type=script&lang=js"
import style0 from "./homeCateList.vue?vue&type=style&index=0&id=48021769&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48021769",
  null
  
)

export default component.exports